import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteUserConfirmDialogComponent } from '../../kb-mycompany-account/delete-user-confirm-dialog/delete-user-confirm-dialog.component';
import { SavedShoppingCartService } from 'src/app/services/feature/savedShoppingCart/saved-shopping-cart.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-delete-saved-cart-dialog',
  templateUrl: './delete-saved-cart-dialog.component.html',
  styleUrls: ['./delete-saved-cart-dialog.component.scss'],
  standalone: false
})
export class DeleteSavedCartDialogComponent {
  subscription = new Subscription();
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any, public dialogRef: MatDialogRef<DeleteSavedCartDialogComponent>,
    private savedShoppingCartService: SavedShoppingCartService,) {

  }
  delete() {
    this.subscription.add(this.savedShoppingCartService.deleteSavedCartDetails(this._data.id).subscribe(data => {
      this.dialogRef.close(data);
    }))
  }

  cancel() {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }


}
